export default "__VITE_ASSET__1OsVENRv__"